export default "<!--\n    Made with <3 by Yann Thoraval\n-->\n\n<app-header></app-header>\n\n<router-outlet></router-outlet>\n\n<app-footer></app-footer>\n"